import { Component, OnInit } from '@angular/core';
import { DataService } from '../shared/dataService';
import { Router } from '@angular/router';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css']
})
export class AccountComponent implements OnInit {

  public dataSource :any = []; 
  public errorMessage: string ="";
  public creds = {
    username : "444",
    password : "1209"
  };
  constructor(private data: DataService,private router: Router) 
  {

  }
  ngOnInit(): void  
  { 

  } 

  onFormSubmit = function(e) 
  {
    this.errorMessage= "";
    this.data.login(this.creds)
      .subscribe(success =>
      {
          if (success)
          {
              console.log("#login succes#"+success);
              this.errorMessage= ""; 
              this.router.navigate((['/']));
          }
      },err=> 
      {
        console.log(err);
        this.errorMessage = "Intento no valido";
        console.log("intento no valido");
      });
  }

  
}
